export enum Views {
	Enter,
	Confirm,
}
